import React, {
  cloneElement,
  FC,
  isValidElement,
  MouseEvent,
  ReactElement,
} from 'react';
import type { TrialFeature } from '@discover-frontend/components';

import { useTrialPaywall } from '../../providers/TrialPaywallProvider';

interface TrialRestrictedProps {
  feature: TrialFeature;
  children: ReactElement;
}

export const TrialRestricted: FC<TrialRestrictedProps> = ({
  feature,
  children,
}) => {
  const { isTrial, openUnlockModal } = useTrialPaywall();

  if (!isTrial || !isValidElement(children)) return children;

  const child = children as ReactElement<{
    onClick?: (event: MouseEvent) => void;
  }>;

  return cloneElement(child, {
    onClick: (event?: MouseEvent) => {
      event?.preventDefault?.();
      event?.stopPropagation?.();
      openUnlockModal(feature);
    },
  });
};
